export const cleanURLParams = (
	params: Record<string, any>,
): Record<string, any> => {
	Number(params?.['page']) === 1 && delete params?.['page']; //remove page if its 1.
	Object.keys(params).forEach(
		(key) =>
			(params[key]?.length === 0 ||
				params[key] === undefined ||
				params[key] === 'undefined') && //Remove stringified undefined
			delete params[key],
	);
	return params;
};
